export const CapacityReportType = {
    CAPACITY_REPORT: 'CAPACITY_REPORT',
    PERFORMED_CAPACITY_REPORT: 'PERFORMED_CAPACITY_REPORT',
};
